export const ADD_MODAL_TABS = {
  FIND: 'find',
  CREATE: 'create',
  DICTIONARY: 'dictionary',
  TYPE: 'type',
};
